import React, {useState} from 'react'
import { useNavigate } from "react-router-dom";
import { MainLayoutAdmin } from "../../../layout/MainLayoutAdmin";
import {HOST} from '../../../config';

export default function Login() {
    const navigate = useNavigate();
    const [username, setUsername] = useState();
    const [password, setPassword] = useState();
    function handleLogin() {
        if (!username || !password) {
            alert('Chưa nhập tài khoản hoặc mật khẩu');
        } else {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
            "userName": username,
            "password": password
            });

            const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
            };

            fetch(`${HOST}/auth`, requestOptions)
            .then(response => response.text())
            .then(result => {
                const {accessToken} = JSON.parse(result);
                localStorage.setItem('accessToken', accessToken);
                console.log(accessToken);
                navigate("/admin"); 
            })
            .catch(error => {
                alert('Có lỗi xảy ra')
                console.log('error', error)
            });
        }
    }
  return (
    <MainLayoutAdmin>
        <div className="px-8 pt-6 pb-8 mb-4 flex flex-col">
    <div className="mb-4">
      <label className="block text-grey-darker text-sm font-bold mb-2" >
        Tài khoản
      </label>
      <input onChange={e => setUsername(e.target.value)} className="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker" id="username" type="text" />
    </div>
    <div className="mb-6">
      <label className="block text-grey-darker text-sm font-bold mb-2" >
        Mật khẩu
      </label>
      <input onChange={e => setPassword(e.target.value)} className="shadow appearance-none border border-red rounded w-full py-2 px-3 text-grey-darker mb-3" id="password" type="password" />
    </div>
    <div className="flex items-center justify-between">
      <button onClick={handleLogin} className="bg-black hover:bg-blue-dark text-white font-bold py-2 px-4 rounded" type="button">
        Đăng nhập
      </button>
    </div>
</div>
    </MainLayoutAdmin>
    
  )
}
